import compression from "browser-image-compression";

const imageCompression = (images: Array<File>) => Promise.all(
    images.map(i => compression(i, {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
    }))
)

export default imageCompression;